const ViewModeType = {
  gallery: 'gallery',
  speaker: 'speaker',
};

export default ViewModeType;
